<div class="bottom-nav-container">
  <div class="bottom-nav-content">
    @if (pageIndex > 0) {
      <button
        class="arrow-button"
        (click)="setPageIndex(pageIndex - 1)"
        aria-label="Previous page"
        >
        <mat-icon>arrow_back</mat-icon>
      </button>
    }
    @if (pageIndex === 0) {
      <div class="fake-arrow-button"></div>
    }

    @for (page of pages; track page; let i = $index) {
      @if (pageIndex === i) {
        <h1 aria-live="assertive">{{ page }}</h1>
      }
    }

    @if (pageIndex < pages.length - 1) {
      <button
        class="arrow-button"
        (click)="setPageIndex(pageIndex + 1)"
        aria-label="Next page"
        >
        <mat-icon>arrow_forward</mat-icon>
      </button>
    }
    @if (pageIndex === pages.length - 1) {
      <div class="fake-arrow-button"></div>
    }
  </div>
</div>
